
import Vue from 'vue';
import RuleService from '@/services/RuleService';
import { extractErrorMessage } from '@/utils/Util';

export default Vue.extend({
  name: 'RuleDeleteDialog',
  props: ['rule'],
  data: () => ({
    localDialog: false,
    alertText: '',
    alertVisible: false,
    alertType: 'error',
    loading: false,
    removeActionEntities: true,
    dismissTimeout: null as ReturnType<typeof setTimeout> | null,
  }),
  methods: {
    close() {
      this.localDialog = false;
    },
    clear() {
      this.alertVisible = false;
      this.loading = false;
      this.removeActionEntities = true;
    },
    dismiss() {
      this.clear();
      this.close();
    },
    confirmDelete() {
      this.loading = true;
      this.alertVisible = false;

      RuleService.deleteRule(
        this.$root.$store.state.session.selectedTenant.uuid,
        this.rule.uuid,
        this.removeActionEntities
      )
        .then(() => {
          this.alertType = 'success';
          this.alertText = this.$t('rule.successDelete') as string;
          this.alertVisible = true;
          this.loading = false;

          this.dismissTimeout = setTimeout(() => {
            this.$emit('delete', this.rule);
            this.dismiss();
          }, 2000);
        })
        .catch((err) => {
          console.error(err);
          this.alertType = 'error';
          this.alertText =
            (this.$t('rule.errorDelete') as string) +
            ' ' +
            extractErrorMessage(err);
          this.alertVisible = true;
          this.loading = false;
        });
    },
  },
  beforeDestroy() {
    if (this.dismissTimeout) clearTimeout(this.dismissTimeout);
  },
  watch: {
    localDialog(value: boolean) {
      if (!value) {
        this.clear();
      }
    },
  },
});
